import type { DimensionScoreLevelName } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

import type { AssessmentBreakdownData } from '../assessMyTrack.types';

export const useAgentContext = (
  breakdown: AssessmentBreakdownData | null,
  scoreLabels: Record<DimensionScoreLevelName, string>,
) => {
  const categories = breakdown
    ? Object.values(breakdown)
        .filter(Boolean)
        .map((category) => ({
          ...category,
          dimensions: category.dimensions.map((d) => ({
            ...d,
            scoreLabel: scoreLabels[d.score],
          })),
        }))
    : [];

  useRegisterAgentContext({
    kind: 'visual',
    label: 'Assessment Breakdown Scorecard',
    display:
      'Grid scorecard with four columns: Academic Foundations, Real-World Experience (Achievement), Mindsets and Skills, and Community of Success. Each column has multiple dimensions scored as Not Yet, Proficient, or Advanced. Only the Academic Foundations column determines the career track. The other three columns (Achievement, Skills, Community) determine profile strength, not the career track. Users can click any dimension to override its score if they believe it is incorrect — for example, if they meet a criteria but have not yet documented the evidence in their profile or resume. Column headings whose standards are available also show an info button opening the standards behind those scores: Academic Foundations shows the standards for each career track, and the other three show the Proficient and Advanced criteria for the student’s current grade.',
    data: { categories },
  });
};
